import { Dialog, Table, TableBody, TableRow, TableRowColumn } from "material-ui";
import ActionCached from "material-ui/svg-icons/action/cached";
import ErrorOutline from "material-ui/svg-icons/alert/error-outline";
import Clear from "material-ui/svg-icons/content/clear";
import { TableHeader } from "material-ui/Table";
import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import images from "../../config/images";
import { tdStyle } from "./QuestionnaireTable";

function ResultExpiredDialog(props) {
  return (
    <div>
      <Dialog
        modal={false}
        open={true}
        onRequestClose={props.handleClose}
        contentStyle={{
          maxWidth: '300px'
        }}
        paperClassName="no-box-shadow"
      >
        <Clear style={{ position: 'absolute', top: '8px', right: '8px', cursor: 'pointer', color: '#656565' }} onClick={props.handleClose} />
       <div style={{ marginTop: '5px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
        <ErrorOutline style={{ height: '50px', width: '50px', color: 'grey', marginBottom: '5px'}} />
        <FormattedMessage id="questionnaire.resultExpired" />
       </div>
      </Dialog>
    </div>
  );
}

class ResultTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showResultExpiredPopup: false
    }
  }


  formatRegisteredDate = (date) => {
    return date ? moment(new Date(date)).format("YYYY/MM/DD HH:mm") : '-';
  };

  render() {
    return (
      <div
        style={{
          marginTop: "10px",
        }}
        className="table-wrapper"
      >
        {this.state.showResultExpiredPopup && 
          <ResultExpiredDialog 
            handleClose={() => this.setState({ showResultExpiredPopup: false})}
          />
        }
        <Table
          selectable={false}
          height="75vh"
          fixedHeader={true}
          selectedColor="black"
          style={{ border: "1px solid #b8b8b8", minWidth: "612px" }}
        >
          <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false} >
            <TableRow
              style={{
                border: "1px solid #b8b8b8",
                backgroundColor: "#6B7c93",
                color: "#fff",
              }}
            >
              <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="questionnaire.sentAt" />}
              </TableRowColumn>
              <TableRowColumn colSpan={3} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="questionnaire.title" />}
              </TableRowColumn>
              <TableRowColumn colSpan={3} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="questionnaire.question" />}
              </TableRowColumn>
              <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="roomList.roomName" />}
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="questionnaire.result" />}
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="questionnaire.reRegister" />}
              </TableRowColumn>
            </TableRow>
          </TableHeader>
          <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>

            {this.props.isFetching ||
              (this.props.questionnaires.length === 0 && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={12} style={tdStyle}>
                    {this.props.isFetching ? (
                      <FormattedMessage id="questionnaire.fetchingQuestionnaire" />
                    ) : (
                      <FormattedMessage id="questionnaire.noQuestionnaireFound" />
                    )}
                  </TableRowColumn>
                </TableRow>
              ))}

            {this.props.questionnaires.map((questionnaire, index) => {
              return (
                <TableRow
                  key={index}
                  selected={false}
                  className={index % 2 == 0 ? "dark-row" : "light-row"}
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={2} style={tdStyle}>
                    {this.formatRegisteredDate(questionnaire.last_submitted_at)}
                  </TableRowColumn>
                  <TableRowColumn colSpan={3} style={{...tdStyle, textAlign: 'left'}}>
                    {questionnaire.title}
                  </TableRowColumn>
                  <TableRowColumn colSpan={3} style={{...tdStyle, textAlign: 'left'}}>
                    {questionnaire.question}
                  </TableRowColumn>
                  <TableRowColumn colSpan={2} style={tdStyle}>
                    {this.props.isRoomFetched ? (
                      this.props.rooms &&
                      this.props.rooms.find(
                        (r) => r.id === questionnaire.room_id
                      ) ? questionnaire.room_name : <FormattedMessage id="questionnaire.deleted" />
                    ) : (
                      ""
                    )}
                  </TableRowColumn>
                  <TableRowColumn style={tdStyle}>
                    {questionnaire.isResultExpired ?
                      <Clear onClick={() => this.setState({ showResultExpiredPopup: true })} style={{ color: '#898989de', height: '20px', width: '20px', cursor: 'pointer' }} /> : <img
                        src={images.editBookIcon}
                        style={{ width: "24px", cursor: "pointer" }}
                        onClick={() => this.props.showResult(questionnaire)}
                      /> 
                    }
                  </TableRowColumn>
                  <TableRowColumn style={tdStyle}>
                    <ActionCached onClick={() => {
                        this.props.editQuestionnaire(questionnaire, true);
                      }} style={{ width: '28px', cursor: 'pointer', height: '28px', color: "#6B7c93" }} />
                  </TableRowColumn>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default ResultTable;



// WEBPACK FOOTER //
// src/components/Questionnaire/ResultTable.js